import {Action, Selector, State, StateContext} from '@ngxs/store';
import {ActiveProducts} from '../../models/product.model';
import {Injectable} from '@angular/core';
import {tap} from 'rxjs/operators';
import {UserService} from '../../services/user.service';
import {ActiveProductsActions} from './active-products.action';

interface ActiveProductStateModel {
    activeProducts: ActiveProducts;
}

@State<ActiveProductStateModel>({
    name: ActiveProductState.STATE_NAME,
    defaults: {
        activeProducts: null,
    }
})

@Injectable()
export class ActiveProductState {

    static readonly STATE_NAME = 'activeProduct';

    constructor(private userService: UserService,
    ) {
    }

    @Selector()
    static activeProducts(state: ActiveProductStateModel) {
        return state.activeProducts;
    }


    @Action(ActiveProductsActions.ActiveProducts)
    activeProducts(ctx: StateContext<ActiveProductStateModel>) {
        return this.userService.getActiveProducts()
            .pipe(tap(activeProducts => ctx.patchState({activeProducts})));
    }
}
